// extracted by mini-css-extract-plugin
export default {"container":"pageNotFound_container__z3GYz","title":"pageNotFound_title__44XiJ","message":"pageNotFound_message__6mnNr","button":"pageNotFound_button__WSxw8"};